import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useQuery } from '@office-start/data-fetching';
import { httpGet } from '../operations/httpGet';
import { getQueryKey } from '../utilities/getQueryKey';
export function useHttpGet(httpGetKey, eventName, otelEventName, url, requestConfig, tokenConsumer, xhrOptions, strategy, staleTime, cacheTime) {
    var _a;
    if (xhrOptions === void 0) { xhrOptions = {}; }
    var queryKey = getQueryKey(httpGetKey);
    var options = (_a = useOfficeComponentContext()) === null || _a === void 0 ? void 0 : _a.data;
    return useQuery(queryKey, function () {
        return httpGet(eventName, otelEventName, url, requestConfig, options.jwtAuthEnabled, options.getAccessToken, options.officeHomeApiRoot, options.correlationId, tokenConsumer, xhrOptions, strategy).then(function (instrumentedHttpResponse) {
            if (!instrumentedHttpResponse.ok) {
                throw new Error("Instrumented response is not ok: ".concat(instrumentedHttpResponse.status, " - ").concat(instrumentedHttpResponse.statusText));
            }
            return instrumentedHttpResponse;
        });
    }, {
        staleTime: staleTime !== null && staleTime !== void 0 ? staleTime : Infinity,
        cacheTime: cacheTime !== null && cacheTime !== void 0 ? cacheTime : Infinity,
        enabled: !!options && !!httpGetKey && !!url,
    });
}
//# sourceMappingURL=useHttpGet.js.map